export default function deleteRentLicenses(api: GlobalFetch) {
  return async function(calendarId, licenseId) {
    const buildUrl = `/api/v2/room/license/id_calendar/${calendarId}/id_license/${licenseId}`
    await api.fetch(buildUrl, {
      method: 'DELETE',
    })
  }
}
